import { render } from "./SortingWidget.vue?vue&type=template&id=04234e08"
import script from "./SortingWidget.vue?vue&type=script&lang=js"
export * from "./SortingWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__